import React from "react";
import { useSelector } from "react-redux";
import { ZustandStore } from "../../../store/zustand-store";
import { useNavigate } from "react-router-dom";
import { getCurrentCountryFlagByCode } from "../../../helperJs/getCountryFlag";
import { useTranslation } from "react-i18next";
import Ellipsis from "@semcore/ellipsis";
import Tooltip from "../components/tooltip";

const SiteOverviewTable = ({ type, title, totalOrganicKeywords }) => {
  const showTotalKeyword = 6;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const keywords = useSelector((state) => state.seoKeyword);
  const data = keywords?.keyword?.[type] || [];

  const tooltips = {
    organic: t("site_audit.dashboard_page.box.organic_keyword.tooltip"),
    ai: t("competitive_research.aio.tooltip"),
  };
  const handleTabChange = () => {
    ZustandStore.setState({
      tag_keywords: [],
      filter_tag: [],
      keyword_tag_data: {
        loaded: false,
        error: false,
        data: [],
      },
    });
    navigate(
      type === "ai"
        ? "/site-overview/aio-keywords"
        : "/site-overview/organic-keywords"
    );
  };

  return (
    <>
      <h4 className="heading-small font-light-bold mb-0">
        {title}
        {tooltips[type] && <Tooltip title={tooltips[type]} />} (
        {totalOrganicKeywords || data?.length})
      </h4>
      <div className="overview-table" style={{ overflow: "hidden" }}>
        <table
          className="h-100"
          style={{
            cursor: "default",
            minHeight: data?.length === 0 ? "243px" : "192px",
          }}
        >
          <thead>
            <tr className="">
              <th scope="col" className="ps-3 p-2" style={{ width: "70%" }}>
                {t("competitive_research.competition_table.keyword")}
              </th>
              <th
                scope="col"
                className="p-2 text-center"
                style={{ width: "30%" }}
              >
                {t("competitive_research.competition_table.position")}
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.length === 0 ? (
              <tr key={`no-data`}>
                <td className="text-center ps-3 keyword-name" colSpan={2}>
                  {t("competitive_research.competition_table.no_keyword")}
                </td>
              </tr>
            ) : (
              data
                ?.slice(
                  0,
                  data?.length > showTotalKeyword
                    ? showTotalKeyword
                    : data?.length
                )
                ?.map((res, index) => {
                  return (
                    <React.Fragment key={`domianviewdata-${index}`}>
                      <tr key={`${index}-${res.rank_group}`}>
                        <td className="t_left ps-3 keyword-name">
                          <span className="d-flex align-items-center">
                            <Ellipsis trim="end">{res.keyword}</Ellipsis>
                            {res?.location && (
                              <img
                                src={getCurrentCountryFlagByCode(res?.location)}
                                alt="flag"
                                className="ms-1"
                                style={{
                                  width: "20px",
                                  objectFit: "contain",
                                }}
                              />
                            )}
                          </span>
                        </td>
                        <td className="text-center">{res.rank_group}</td>
                      </tr>
                    </React.Fragment>
                  );
                })
            )}
          </tbody>
        </table>
        {data?.length > showTotalKeyword && (
          <div className="see-more-link" style={{ textDecoration: "auto" }}>
            <button
              className={`btn-sm float-right`}
              style={{ fontSize: "1em !important" }}
              onClick={() => handleTabChange()}
            >
              {t("common_buttons.view_all")}
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default SiteOverviewTable;
